/**
 * ProductDetailPresenter
 * --
 */
import { Content, Row, Col, Title } from 'components';
import { useNavigate } from 'react-router-dom';
import styles from './styles';

import {
  SalesInformation,
  ProductOptionInformation,
  ProductDetailInformation,
  ProductDeliveryInformation,
  ProductImageInformation,
  ProductHashtagInformation,
  ProductPaymentAdditionalInformation,
} from './components';

import { Button } from 'antd';

/**----------------------------------------
 * [Component] 총관리자: 상품상세보기 - 프레젠터
 * ----------------------------------------
 */
const ProductDetailPresenter = ({ productData, searchLocation }) => {
  /* ===== ROUTE ===== */
  const navigate = useNavigate();
  /* ===== PROPS ===== */
  /* ===== STATE ===== */
  /* ===== VARIABLE ===== */
  /* ===== HOOKS ===== */

  /* ===== FUNCTION ===== */
  /**
   *
   * --
   */
  const handleClickProductEdit = () => {
    if (searchLocation) {
      navigate(`/product/register${searchLocation}`, {
        state: productData,
      });
      return;
    }
    navigate(`/product/register`, {
      state: productData,
    });
  };

  // console.log('[ProductDetailPresenter] productData: ', productData);

  /* ===== RENDER ===== */
  // JSX: start
  return (
    <Content maxWidth={'100%'} padding={20} backgroundColor={'none'}>
      <Row>
        <Col x={24}>
          <Title size={3} style={{ marginBottom: 10 }}>
            <div style={{ width: '100%' }}>상품 상세</div>
            <div
              style={{
                width: '100%',
                display: 'flex',
                justifyContent: 'right',
                alignItems: 'center',
              }}
            >
              <Button onClick={handleClickProductEdit}>수정하기</Button>
            </div>
          </Title>
          {/* 판매정보: start */}
          <SalesInformation data={productData} />
          {/* 판매정보: end */}

          {/* 이미지: start 정보 */}
          <ProductImageInformation data={productData} />
          {/* 이미지: start end */}

          {/* 옵션정보: start */}
          <ProductOptionInformation data={productData} />
          {/* 옵션정보: end */}

          {/* 상세정보: start 설정 */}
          {/* <ProductDetailInformation2
            defaultData={productData?.product_detail}
          /> */}
          <ProductDetailInformation data={productData?.product_detail} />
          {/* 상세정보: start end */}

          {/* 결제부가정보: start 설정 */}
          <ProductPaymentAdditionalInformation
            data={productData?.payment_additional_information}
          />
          {/* 결제부가정보: start end */}

          {/* 배송정보: start */}
          <ProductDeliveryInformation data={productData} />
          {/* 배송정보: end */}

          {/* 태그: start 설정 */}
          <ProductHashtagInformation data={productData} />
          {/* 태그: start end */}
        </Col>
      </Row>
    </Content>
  ); // JSX: end
};

export default ProductDetailPresenter;
